export const tro10DataEn = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.wm.com/us/en/dumpster-rental/10-yard",
      url: "https://www.wm.com/us/en/dumpster-rental/10-yard",
      name: "10 Yard Dumpster Rental | WM",
      primaryImageOfPage: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/10-yard/#primaryimage",
      },
      image: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/10-yard/#primaryimage",
      },
      thumbnailUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/10-yard/10-yd-header.jpg",
      description:
        "Our 10 yard dumpster rentals are the perfect solution for small construction projects and handling of heavy material. Schedule your rental online today.",
    },
    {
      "@type": "ImageObject",
      inLanguage: "en-US",
      "@id": "https://www.wm.com/us/en/dumpster-rental/10-yard/#primaryimage",
      url: "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/10-yard/10-yd-header.jpg",
      contentUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/10-yard/10-yd-header.jpg",
      width: 545,
      height: 327,
      caption: "10 yard dumpster dimensions",
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.wm.com/us/en/dumpster-rental/10-yard/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.wm.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Dumpster Rental",
          item: "https://www.wm.com/us/en/dumpster-rental",
        },
        { "@type": "ListItem", position: 3, name: "10-Yard" },
      ],
    },
  ],
}

export const tro10ProductDataEn = {
  "@context": "https://schema.org",
  "@type": "Product",
  "@id": "https://www.wm.com/us/en/dumpster-rental/10-yard/#product",
  name: "10 Yard Dumpster Rental | WM",
  image:
    "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/10-yard/10-yd-header.jpg",
  description:
    "Our 10 yard dumpster is our smallest size and is ideal for smaller construction projects. Typically measuring 15’ x 8’ x 2’, our 10 yard dumpsters fit moderate amounts of roofing materials, construction debris and other heavy materials. Schedule delivery and additional pickups conveniently online using My WM.",
  url: "https://www.wm.com/us/en/dumpster-rental/10-yard",
  mainEntityOfPage: "https://www.wm.com/us/en/dumpster-rental/10-yard",
  isRelatedTo: [
    "12 Yard Dumpster",
    "15 Yard Dumpster",
    "20 Yard Dumpster",
    "30 Yard Dumpster",
    "40 Yard Dumpster",
  ],
  brand: { "@type": "Brand", "@id": "https://www.wm.com/#brand" },
}
